import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics as VercelAnalytics } from '@vercel/analytics/react';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Sites from './pages/Dashboard'; // Dashboard page renamed to Sites
import Dashboard from './pages/Analytics'; // Analytics page renamed to Dashboard
import Content from './pages/Content';
import PageDashboard from './pages/PageDashboard';
import Compliance from './pages/Compliance';
import CompliancePublic from './pages/CompliancePublic';
import Revenue from './pages/Revenue';
import EditProfile from './pages/EditProfile';
import CookiePolicy from './pages/CookiePolicy';
import SimpleOAuthCallback from './pages/SimpleOAuthCallback';
import VerifyEmail from './pages/VerifyEmail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Billing from './pages/Billing';
import Pricing from './pages/Pricing';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import AdminSetup from './pages/AdminSetupSimple';
import WaitlistPending from './pages/WaitlistPending';
import AnalyticsFeatures from './pages/AnalyticsFeatures';
import ContentFeatures from './pages/ContentFeatures';
import ComplianceFeatures from './pages/ComplianceFeatures';
import RevenueFeatures from './pages/RevenueFeatures';
import Growth from './pages/Growth';
import MetricsDictionary from './pages/MetricsDictionary';
import Guides from './pages/Guides';
import AdSenseGuide from './pages/AdSenseGuide';
import Alerts from './pages/Alerts';
import AdSenseApproval from './pages/AdSenseApproval';
import Demo from './pages/Demo';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="app-container">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/analytics-features" element={<AnalyticsFeatures />} />
              <Route path="/content-features" element={<ContentFeatures />} />
              <Route path="/compliance-features" element={<ComplianceFeatures />} />
              <Route path="/revenue-features" element={<RevenueFeatures />} />
              <Route path="/metrics-dictionary" element={<MetricsDictionary />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/termsofservice" element={<TermsOfService />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/demo" element={<Demo />} />
              {/* Legacy routes - redirect to new structure */}
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />
              {/* New Analytics routes */}
              <Route 
                path="/analytics/overview" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/analytics/content" 
                element={
                  <PrivateRoute>
                    <Content />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/analytics/revenue" 
                element={
                  <PrivateRoute>
                    <Revenue />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/analytics/alerts" 
                element={
                  <PrivateRoute>
                    <Alerts />
                  </PrivateRoute>
                } 
              />
              {/* Legacy routes for backward compatibility */}
              <Route 
                path="/content" 
                element={
                  <PrivateRoute>
                    <Content />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/revenue" 
                element={
                  <PrivateRoute>
                    <Revenue />
                  </PrivateRoute>
                } 
              />
              {/* Growth route */}
              <Route 
                path="/growth/adsense" 
                element={<AdSenseApproval />} 
              />
              {/* Legacy growth route - redirect to alerts */}
              <Route 
                path="/growth" 
                element={
                  <PrivateRoute>
                    <Growth />
                  </PrivateRoute>
                } 
              />
              {/* Legacy growth/alerts route - redirect to analytics/alerts */}
              <Route 
                path="/growth/alerts" 
                element={
                  <PrivateRoute>
                    <Growth />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/profile" 
                element={
                  <PrivateRoute>
                    <EditProfile />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/sites" 
                element={
                  <PrivateRoute>
                    <Sites />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/page/:contentId" 
                element={
                  <PrivateRoute>
                    <PageDashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/compliance" 
                element={
                  <PrivateRoute>
                    <Compliance />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/compliance-checker" 
                element={<CompliancePublic />} 
              />
              <Route 
                path="/auth/google-oauth-callback" 
                element={<SimpleOAuthCallback />}
              />
              <Route 
                path="/verify-email" 
                element={<VerifyEmail />}
              />
              {/* Admin Routes */}
              <Route path="/admin/setup" element={<AdminSetup />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/dashboard" 
                element={<AdminDashboard />}
              />
              <Route path="/waitlist" element={<WaitlistPending />} />
              <Route 
                path="/billing" 
                element={
                  <PrivateRoute>
                    <Billing />
                  </PrivateRoute>
                }
              />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/adsense" element={<AdSenseGuide />} />
              {/* Legacy alerts route - redirect to analytics/alerts */}
              <Route 
                path="/alerts" 
                element={
                  <PrivateRoute>
                    <Alerts />
                  </PrivateRoute>
                } 
              />
            </Routes>
          </main>
          <Footer />
        </div>
        <VercelAnalytics />
      </Router>
    </AuthProvider>
  );
}

export default App;

